import {
	jsonArrayProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'
import { LicenseLimitations } from './license-limitations.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

export type LicenseType =
	| 'Evaluation'
	| 'Basic'
	| 'Development'
	| 'Production'
	| 'Personal'

@jsonClass('License')
export class License {
	@jsonProperty(String)
	get __type() {
		return 'License'
	}
	set __type(_) {}

	@jsonProperty(Number)
	formatVersion: number = 1

	@jsonProperty(String)
	clientId: string = ''
	@jsonProperty(String)
	ownerName: string = ''
	@jsonProperty(String)
	ownerContactPerson: string = ''
	@jsonProperty(String)
	contractId: string = ''
	@jsonProperty(String)
	contractName: string = ''
	@jsonProperty(Number)
	versionOfLicenseForContract: number = 1
	@jsonProperty(Date)
	validFrom!: Date
	@jsonProperty(Date)
	validTo!: Date
	@jsonProperty(String)
	licenseType?: LicenseType
	@jsonProperty(String)
	validForPlatformVersions: string = ''
	@jsonArrayProperty(String)
	validForHostnames: string[] = ['*']

	@jsonProperty(LicenseLimitations)
	limitations: LicenseLimitations

	@jsonProperty(Date)
	issuedOnDate?: Date
	@jsonProperty(String)
	issuedBy: string = ''
	@jsonProperty(String)
	comments: string = ''

	@jsonProperty(String)
	signature: string | undefined = undefined

	constructor(init: Omit<License, '__type'>) {
		assignCommonProperties(this, init)
		this.limitations = new LicenseLimitations(init?.limitations)
	}
}
